//      
import React, { Component } from 'react';
import styled from 'styled-components';
import { capitalize } from 'lodash';

import Card from 'bs/Card';

                     
                     
                  
                       
                    
  

              
                  
  

const getBorderColor = ({ theme, flavor }) => {
    return theme.color[`border${capitalize(flavor)}`];
};

const StyledPopover = styled.div`
    position: relative;

    .popover {
        position: absolute;
        bottom: 2.5rem;
        left: -1rem;
        width: 30rem;
        @media (max-width: 767px) {
            width: 90vw;
        }

        .card {
            border: solid 1px ${props => getBorderColor(props)} !important;
        }

        &::after {
            content: '';
            position: absolute;
            bottom: -0.5rem;
            left: 1.5rem;
            border-width: 0.5rem 0.5rem 0 0.5rem;
            border-style: solid;
            border-color: ${props => getBorderColor(props)} transparent transparent
                transparent;
            display: block;
            width: 1rem;
            height: 0rem;
        }
    }

    &.float-right {
        .popover {
            left: inherit;
            right: -1rem;
            &::after {
                left: inherit;
                right: 1.5rem;
            }
        }
    }
`;

export class Popover extends Component               {
    static defaultProps = {
        flavor: 'light',
    };

    constructor() {
        super();
        this.state = {
            show: false,
        };
        this.togglePopover = this.togglePopover.bind(this);
    }

    togglePopover = () => {
        this.setState({ show: !this.state.show });
    };

    render() {
        const { placeHolder, contents, disabled = false, className, flavor, ...domProps } = this.props;

        return (
            <StyledPopover className={className} flavor={flavor} {...domProps}>
                <div
                    onClick={() => (!disabled ? this.togglePopover(): null)}
                    style={{ cursor: !disabled ? 'pointer' : 'inherit' }}
                >
                    {placeHolder}
                </div>
                {this.state.show === true && (
                    <div className='popover'>
                        <Card className='p-1 mb-0' flavor={flavor}>
                            {contents}
                        </Card>
                    </div>
                )}
            </StyledPopover>
        );
    }
}

export default Popover;
